import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { getDiscountListSvc } from './DiscountSvc';

const DiscountTable = (props) => {
    const [lstDiscount, setLstDiscount] = useState([])
    const [loader, setLoader] = useState('none')
    const [selDiscountId, setSelDiscountId] = useState(0)
    useEffect(() => {
        setLoader('block')
        getDiscountListSvc(handleDiscountResponse)
    }, [props.randNo]);
    function handleDiscountResponse(data) {
        setLstDiscount(data.lstDiscount)
        setLoader('none')
    }

    async function editDiscount(discountId) {
        for (var i = 0; i < lstDiscount.length; i++) {
            if (lstDiscount[i].discountId === discountId) {
                props.setDiscountForEdit(lstDiscount[i].discountId, lstDiscount[i])
                break;
            }
        }
    }

    function handleSelDiscountId(param) {
        setSelDiscountId(param)
    }
    const colgrp = <colgroup>
        <col width="15%"></col>
        <col width="45%"></col>
        <col width="25%"></col>
        <col width="15%"></col>
    </colgroup>
    return (
        <div style={{ pointerEvents: loader === "none" ? "auto" : "none", marginTop: 15 }}>
            <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: loader }}>
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>

            <table className='tableLayout1'>
                {colgrp}
                <thead>
                    <tr>
                        <th>Discount</th>
                        <th className='text-left'>Label</th>
                        <th>Remarks Mandatory</th>
                        <th>Action</th>
                    </tr>
                </thead>
            </table>
            <div className='tablebodyWrapper'>
                <table className='tableLayout'>
                    {colgrp}
                    <tbody>{
                        lstDiscount.map((discount, idx) => {
                            return <tr onClick={(e) => handleSelDiscountId(discount.discountId)} className={discount.discountId === selDiscountId ? "selected" : ""}
                                key={idx} >
                                <td>{discount.discountId}</td>
                                <td className='text-left'>{discount.discountLabel}</td>
                                <td>
                                    <input type='checkbox' checked={!!discount.remarksMandatory} readOnly disabled />
                                </td>
                                <td className="text-center">
                                    <span title="edit" className="glyphicon glyphicon-edit" onClick={(e) => editDiscount(discount.discountId)}></span>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>

        </div>
    );
};


export default DiscountTable;
